import dynamicClass from 'clsx';
import './checkbox.scss';

const Checkbox = (props: any): any => {
  const { checkActive, checkClick, square, className } = props;

  const classCheckBox = dynamicClass({
    'a-checkbox': true,
    square,
    [className]: className,
    'square--active': square && checkActive,
  });
  return (
    <div className={classCheckBox} onClick={checkClick} data-testid="checkbox">
      {square && checkActive ? (
        <i className="icon-check1" />
      ) : (
        <>{checkActive && <div className="a-checkbox--active" />}</>
      )}
    </div>
  );
};

export default Checkbox;
